import { render, staticRenderFns } from "./TestCalculationReleaseDialog.vue?vue&type=template&id=2481599f"
import script from "./TestCalculationReleaseDialog.vue?vue&type=script&lang=js"
export * from "./TestCalculationReleaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports